import React from "react"
import { StaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

const ImageFromDrupal = (props) => (
  // <StaticQuery
  //   query={graphql`
  //     query {
  //       images: allFileFile {
  //         edges {
  //           node {
  //             drupal_internal__fid
  //             localFile {
  //               extension
  //               SlugifiedPublicUrl
  //               name
  //               childImageSharp {
  //                 fluid(quality: 100, maxWidth: 1920) {
  //                   ...GatsbyImageSharpFluid_withWebp
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   `}
  //   render={(data) => {
  //     const image = data.images.edges
  //       .filter(({ node }) => node.drupal_internal__fid === props.drupal_fid)
  //       .shift()
  //     if (!image) {
  //       return null
  //     }
  //     if (
  //       !image.node.localFile.childImageSharp &&
  //       image.node.localFile.extension === "svg"
  //     ) {
  //       return (
  //         <img
  //           className={props.className}
  //           alt={props.alt}
  //           src={image.node.localFile.SlugifiedPublicUrl}
  //         />
  //       )
  //     } else if (
  //       !image.node.localFile.childImageSharp &&
  //       image.node.localFile.extension === "gif"
  //     ) {
  //       return (
  //         <img
  //           style={{ width: "100%" }}
  //           alt="gif"
  //           src={image.node.localFile.SlugifiedPublicUrl}
  //         />
  //       )
  //     }
  //     return (
  //       <Img
  //         className={props.className}
  //         alt={props.alt}
  //         fluid={image.node.localFile.childImageSharp.fluid}
  //       />
  //     )
  //   }}
  // />
  <StaticQuery
    query={graphql`
      query {
        images: allFileFile {
          edges {
            node {
              drupal_internal__fid
              localFile {
                extension
                SlugifiedPublicUrl
                name
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const image = data.images.edges
        .filter(({ node }) => node.drupal_internal__fid === props.drupal_fid)
        .shift()
      if (!image) {
        return null
      } else if (image.node.localFile) {
        return (
          <img
            className={props.className}
            style={{ margin: "0" }}
            alt={props.alt}
            src={image.node.localFile.SlugifiedPublicUrl}
            aria-hidden={props.ariaHidden}
          />
        )
      }
    }}
  />
)

//-----------------------Prop-Types---------------------------//

ImageFromDrupal.propTypes = {
  drupal_fid: PropTypes.number.isRequired,
  className: PropTypes.string,
  alt: PropTypes.string,
  ariaHidden: PropTypes.bool,
}

//-----------------------Prop-Types---------------------------//

export default ImageFromDrupal
